import React from 'react';
import { Redirect, useGlobalSearchParams, useSegments } from 'expo-router';
import { anonymousReckoningPresentionKey, anonymousStackKey, branchingKey, privateKey, sessionStackKey } from '../../../constants/routeKeys';
import { concatPath } from '../../../utils/links/concatPath';
import { observer } from 'mobx-react';


const Session = observer(() => {
  const params = useGlobalSearchParams();
  const segment = useSegments();

  const pathId = params?.pathId;
  const sessionId = params.sessionId;
  const reckoningId = params.reckoningId;
  const fromPath = params.fromPath;

  const isInPrivateStack = segment.includes(privateKey);

  // Anonymous reckoning entry (e.g. the shared "/session/regular?fromReckoning=true..."
  // link): route through the terms/GDPR presentation, which then navigates to the
  // (shared) branching screen. Redirecting straight to the private branching route
  // would hit the authentication guard and bounce the visitor to login.
  if (!isInPrivateStack) {
    return (
      <Redirect
        href={{
          pathname: concatPath([anonymousStackKey, anonymousReckoningPresentionKey], -1) as string,
          params: {
            reckoningId: reckoningId as string,
          }
        }}
      />
    );
  }

  // Authenticated users go straight to the branching tree navigation.
  return (
    <Redirect
      href={{
        pathname: concatPath([sessionStackKey, branchingKey], 1) as string,
        params: {
          id: sessionId as string,
          source: 'SESSION',
          pathId: pathId as string,
          sessionId: sessionId as string,
          reckoningId: reckoningId as string,
          fromPath: fromPath as string,
        }
      }}
    />
  );
});

export default Session;
